function NRVulnVoltIcon({ height = '24', width = '24', color = 'currentColor' }) {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.6898 2.21042L4.32985 11.4904C3.68985 12.0704 4.04985 13.1404 4.90985 13.2204L12.9998 14.0004L8.14984 20.7604C7.92984 21.0704 7.95984 21.5004 8.22984 21.7704C8.52984 22.0704 8.99985 22.0804 9.30984 21.7904L19.6698 12.5104C20.3098 11.9304 19.9498 10.8604 19.0898 10.7804L10.9998 10.0004L15.8498 3.24042C16.0698 2.93042 16.0398 2.50042 15.7698 2.23042C15.4698 1.93042 14.9998 1.92042 14.6898 2.21042Z"
        fill={color}
      />
    </svg>
  );
}

export default NRVulnVoltIcon;
